import { Helmet } from "react-helmet-async";

export function StructuredData() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "長安跨越 電動車",
    alternateName: "Global Alliances (Asia)",
    url: "https://www.changankuayue.hk",
    logo: "https://www.changankuayue.hk/img/V7七座版-整车效果图3.webp",
    description:
      "長安跨越香港獨家代理。專營電動七人車，適合網約車及商業用途。",
    address: {
      "@type": "PostalAddress",
      streetAddress: "海濱道133號萬兆豐中心22樓K1室",
      addressLocality: "觀塘",
      addressRegion: "香港",
      addressCountry: "HK",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+852-9323-9473",
      contactType: "sales",
      availableLanguage: ["Chinese", "English"],
    },
    sameAs: [],
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "長安跨越 電動車",
    url: "https://www.changankuayue.hk",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.changankuayue.hk/?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "AutoDealer",
    name: "長安跨越 電動車 - 香港展示廳",
    image: "https://www.changankuayue.hk/img/V7七座版-整车效果图3.webp",
    url: "https://www.changankuayue.hk",
    telephone: "+852-9323-9473",
    address: {
      "@type": "PostalAddress",
      streetAddress: "海濱道133號萬兆豐中心22樓K1室",
      addressLocality: "觀塘",
      addressRegion: "香港",
      addressCountry: "HK",
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "00:00",
      closes: "23:59",
    },
    priceRange: "HK$198,000 - HK$250,000",
  };

  const siteNavigationSchema = {
    "@context": "https://schema.org",
    "@type": "SiteNavigationElement",
    name: "主導航",
    hasPart: [
      {
        "@type": "WebPage",
        name: "首頁",
        url: "https://www.changankuayue.hk/",
      },
      {
        "@type": "WebPage",
        name: "車型展示",
        url: "https://www.changankuayue.hk/products",
      },
      {
        "@type": "WebPage",
        name: "聯絡我們",
        url: "https://www.changankuayue.hk/contact",
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(siteNavigationSchema)}
      </script>
    </Helmet>
  );
}
